import type { INote, ISchema } from "~/models/IUserEntry";

interface State {
  lastSavedEntry: INote | ISchema | undefined;
}

export const useLastSavedEntryStore = defineStore("last_saved_entry", {
  state: (): State => ({
    lastSavedEntry: undefined,
  }),
  actions: {
    setLastSavedEntry(entry?: INote | ISchema) {
      this.lastSavedEntry = entry;
    },
  },
});
